import { render, staticRenderFns } from "./PlanTile.vue?vue&type=template&id=47d140c4"
import script from "./PlanTile.vue?vue&type=script&lang=ts"
export * from "./PlanTile.vue?vue&type=script&lang=ts"
import style0 from "./PlanTile.vue?vue&type=style&index=0&id=47d140c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports